import { LabRequestFormMode, LabRequestType } from "@/Common/Models/Patient/LabRequest";
import { RequestsInboxItem } from "@/Portfolio/Models/MyNotesInboxItem";

import styles from "./PlanSection.module.scss";

interface IExamRequestsProps {
    isEditMode: boolean;
    isReadOnly: boolean;
    requests: JSX.Element[];
    showRequestPopup: (requestItem: RequestsInboxItem, formMode: LabRequestFormMode, requestType?: LabRequestType) => void;
}

function ExamRequests(props: IExamRequestsProps): JSX.Element {
    const canQuickSignDocuments = cacheStore.ClinicSettings.EnableQuickDocumentSigning && !props.isReadOnly && props.requests.length > 0;

    return (
        <tr>
            <td className="c1 bottom-pad">
                <div className={canQuickSignDocuments ? "margin-md-top" : ""}>
                    <strong>{cacheStore.GetString("ExamRequestLabel")}</strong>
                </div>
            </td>
            <td className="c2">
                <div className="tb-row tb">
                    <div className={`add-btn-column ${canQuickSignDocuments ? "padding-md-top" : ""}`}>
                        {props.isEditMode &&
                            <a onClick={() => props.showRequestPopup(null, LabRequestFormMode.Creating)} data-cy="examRequests-addRequest">[+]</a>
                        }
                    </div>
                    <div className="note-items-column" data-cy="examRequests-request">
                        {props.isEditMode && cacheStore.IsChristus() && (
                            <div className={`${styles.christusContainer} flex-container flex-start`}>
                                <a onClick={() => props.showRequestPopup(null, LabRequestFormMode.Creating, LabRequestType.RIS)}>
                                    {`${cacheStore.GetString("NewXRequestLabel").replace("{0}", "RIS")}`}
                                </a>
                                {cacheStore.ClientIdentifier.toLowerCase() == "christustest" && (
                                    <div>
                                        <span className="padding-sm-right padding-sm-left">|</span>
                                        <a onClick={() => props.showRequestPopup(null, LabRequestFormMode.Creating, LabRequestType.LIS)}>
                                            {`${cacheStore.GetString("NewXRequestLabel").replace("{0}", "LIS")}`}
                                        </a>
                                    </div>
                                )}
                            </div>
                        )}
                        <div className={canQuickSignDocuments ? styles.requestContainerFormatted : styles.requestContainer}>
                            {!isArrayNullOrUndefinedOrEmpty(props.requests) ? props.requests : ""}
                        </div>
                    </div>
                </div>
            </td>
        </tr>
    );
}

export { ExamRequests };
